// extracted by mini-css-extract-plugin
export default {"container":"style_container__MFdVR","title":"style_title__sx1u6","divider":"style_divider__192rL","children":"style_children__LGnk+","formFooter":"style_formFooter__JoFgG"};